/*jshint esversion: 6 */
import { createWebHashHistory, createRouter } from 'vue-router';
import loginPage from '../vue/pages/login.vue';
// import searchSwb from '../vue/pages/searchSwb.vue';
// import paeBox from './../vue/pages/paeBox.vue';
// import adminBox from './../vue/pages/admin.vue';
// import logoutPage from './../vue/pages/logout.vue';
import HomeBox from './../vue/pages/home.vue';

const routes = [
    {path: '/', component: HomeBox, name: 'home'},
    // {path: '/admin', component: adminBox, name: 'admin'},
    {path: '/login', component: loginPage, name: 'login'},
    // {path: '/logout', component: logoutPage, name: 'logout'},
    // {path: '/pae', component: paeBox, name: 'pae'},
    // {path: '/search', component: searchSwb, name: 'index'},
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});


router.afterEach((to, from) => {
    if (!from.name) {
        router.push('/');
    }
    switch(to.path) {
        case '/':
        break;
        case '/admin':
            switch(from.path) {
                case '/search':
                    return true;
                default: 
                    router.push('/');
            }
        break;
        case '/login':
            if (from.path !== '/') {
                router.push('/');
            }
        break;
        case '/logout':
            switch(from.path) {
                case '/search':
                case '/pae':
                case '/admin':
                    return true;
                default: 
                    router.push('/');
            }
        case '/pae':
            switch(from.path) {
                case '/search':
                    return true;
                default: 
                    router.push('/');
            }

        case '/search':
            switch(from.path) {
                case '/':
                case '/pae':
                case '/admin':
                case '/login':
                    return true;
                default: 
                    router.push('/');
            }
        break;
        default: 
            window.location.href = "index.php";
    }
});
export default router;